import actionTypes from '../constants/action-types';
import generateId from '../helpers/generate-id';

const copyPage = (
  targetPageId,
  locale,
  title,
  displayInNavigation = false,
  isMultilingualSite = false,
  name = null
) => ({
  type: actionTypes.COPY_PAGE,
  payload: {
    targetPageId,
    displayInNavigation,
    locale,
    title,
    name: name || title,
    pageId: generateId(),
    isMultilingualSite,
  },
});

export default copyPage;
